<template>
    <div v-if="!requisicaoFinalizada" class="loading-overlay">
        <div class="spinner"></div>
    </div>
    <div v-if="requisicaoFinalizada">
        <header class="site-header">
            <div class="logo" :class="{ 'logo-mobile': isMobile }" style="margin-inline: auto; margin-top: 30px; margin-bottom: 30px">
                <img src="@/assets/logoHeader.png" v-if="nomeEmpresa == 'BRITECH' || nomeEmpresa == 'DNWAYS_DEMO_Y' || nomeEmpresa == 'DNWAYS_DEMO_X'" style="filter: invert(60%);" />
                <img src="@/assets/dnways.png" v-if="nomeEmpresa == 'Vortex'" />
                <img src="@/assets/logoActual_v2.png" v-if="nomeEmpresa == 'ACTUAL'"
                    style="width: 100%; height: 100%;" />
                <img src="@/assets/logogenial.png" v-if="nomeEmpresa == 'GENIAL'" style="width: 100%; height: 100%;" />
                <img src="@/assets/logoHeader_rji.png" v-if="nomeEmpresa == 'RJI'" />
            </div>
            <nav class="navigation">
                <ul>

                </ul>
            </nav>
        </header>
        <div class="container">
            <div class="header" v-if="situacaoDocumento != null && situacaoDocumento.Status == 'Pendente' && !situacaoDocumento.DataAssinatura">
                <h3 v-if="this.user">Olá, {{ situacaoDocumento.NomeAssinante }}. O documento abaixo está pendente para sua
                    assinatura, veja os termos e condições: </h3>
                <h3 v-if="!this.user">Olá. O documento abaixo está pendente para sua assinatura, veja os termos e
                    condições: </h3>
                <h3>{{ situacaoDocumento.NomeDocumento }}</h3>
                <div class="document-container" :class="{ 'document-container-mobile': isMobile }">
                    <span v-html="conteudoTermosFormatado">
                    </span>
                </div>

                <label class="termos-row">
                    <input type="checkbox" v-model="aceitoTermos" />
                    <span class="termos-text">Declaro que li e aceito os termos do documento.</span>
                </label>
                
                <button
                type="button"
                :class="{ disabledBtnCustom: disableBtnLogin || !aceitoTermos }"
                @click.stop="assinarDocumento"
                @keyup.enter.stop.prevent
                class="submit-button"
                style="width:40%"
                >
                <span class="btnText" v-if="!disableBtnLogin">Confirmar assinatura</span>
                <div class="loadingDots" v-else><span class="dot">.</span><span class="dot2">.</span><span class="dot3">.</span></div>
                </button>
            </div>

        <div v-if="mostrarCardAssinado" class="signed-card">
            <h3>Documento já foi assinado</h3>
            <ul class="signed-meta">
                <li><strong>Documento:</strong> {{ situacaoDocumento.NomeDocumento }}</li>
                <li><strong>Assinante:</strong> {{ situacaoDocumento.NomeAssinante }}</li>
                <li><strong>Data:</strong> {{ situacaoDocumento.DataAssinatura }}</li>
            </ul>

            <!-- Preview do HTML assinado (Conteudo) -->
            <div ref="docPreview" class="document-preview" v-html="conteudoTermos"></div>

            </div>

        </div>

        <div v-if="mostrarCardDocumentoInvalido" class="signed-card">
            <h3>Documento está indisponível para assinatura</h3>
        </div>

        
    </div>
</template>

<script>

import api from '@/api/axios';
import { mapGetters } from 'vuex';

export default {
    name: 'ConfirmarConta',
    computed: {
        ...mapGetters({
            situacaoDocumento: 'GET_SITUACAO_DOCUMENTO_ASSINATURA',
            user: 'auth/user'
        }),
        conteudoTermosFormatado() {
            return this.conteudoTermos.replace(/<a href/g, '<a target="_blank" href');
        }
    },
    data() {
        return {
            mostrarCardAssinado: false,
            mostrarCardDocumentoInvalido: false,
            aceitoTermos: false,
            nomeEmpresa: '',
            guidAssinatura: '',
            messageError: null,
            erro: false,
            disableBtnLogin: false,
            conteudoTermos: '',
            requisicaoFinalizada: false,
            isMobile: window.innerWidth <= 768
        };
    },
    mounted() {
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
        this.guidAssinatura = this.$route.params.id;
        this.$store.dispatch('FETCH_CONSULTA_ASSINANTE_DOCUMENTO', this.guidAssinatura);
        this.disableBtnLogin = false;
        
        // Add resize event listener to update isMobile
        window.addEventListener('resize', this.checkMobile);
    },
    
    beforeUnmount() {
        // Remove event listener when component is unmounted
        window.removeEventListener('resize', this.checkMobile);
    },
    watch: {
    situacaoDocumento() {
            this.requisicaoFinalizada = true;
            const s = this.situacaoDocumento;
            if (!s) return;

            if (s.Status === 'Pendente' && !s.DataAssinatura) {
                this.conteudoTermos = s.Conteudo;
                this.mostrarCardAssinado = false;

                return;
            }else if (s.Status === 'INATIVO') {
                this.mostrarCardAssinado = false;
                this.mostrarCardDocumentoInvalido = true;

                this.$swal({
                    icon: 'warning',
                    title: 'Atenção',
                    text: 'Documento está indisponível para assinatura.'
                });
                return;

            }
            else {
            // mantém o Conteudo para preview/gerar PDF
                this.conteudoTermos = s.Conteudo;
                this.mostrarCardAssinado = true;

                return;
            }

        }
    },
    methods: {
        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        },
        async getIpAddress() {
            try {
                const response = await fetch("https://api.ipify.org?format=json");
                const data = await response.json();
                return data.ip;
            } catch (error) {
                console.error("Error fetching IP address:", error);
                return null;
            }
        },
        async assinarDocumento() {
            if (this.disableBtnLogin) return;

            if (!this.aceitoTermos) {
                this.$swal({
                icon: 'warning',
                title: 'Atenção',
                text: 'Você precisa aceitar os termos antes de confirmar a assinatura.'
                });
                return;
            }

            const confirm = await this.$swal({
                icon: 'question',
                title: 'Confirmação de assinatura',
                text: 'Você confirma que leu e aceita os termos?',
                showCancelButton: true,
                confirmButtonText: 'Sim, assinar',
                cancelButtonText: 'Cancelar'
            });

            if (!confirm.isConfirmed) return;


            var ip = await this.getIpAddress();
            if (!ip) {
                console.error("Error fetching IP address:");
                this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: `Falha na validação da assinatura`,
                        });
            }
            this.disableBtnLogin = true;
            if (this.guidAssinatura == '') {
                this.messageError = 'Verifique os dados';
                this.erro = true;
                return;
            }
            var model = { Guid: this.guidAssinatura, Ip: ip }
            await api
                .post('/declaracao/assinar', model)
                .then((retorno) => {
                    this.disableBtnLogin = false;
                    if (!retorno.data) {
                        this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: `Falha na validação da assinatura`,
                        });
                    }
                    else {
                        this.$swal({
                            icon: 'success',
                            title: 'Documento assinado!',
                            text: `O assinatura foi realizada com sucesso!`,
                        });
                        this.$store.dispatch('FETCH_CONSULTA_ASSINANTE_DOCUMENTO', this.guidAssinatura);

                    }
                })
                .catch((error) => {
                    this.disableBtnLogin = false;
                    this.disableBtn = false;
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: `${error.response.data.descricao}`,
                    });
                });
        },
        logoff() {
            this.$store.dispatch('auth/logout');
        },
    }
};

</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

body,
html {
    height: 100%;
    margin: 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;
}

.site-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0rem 2rem;
    background-color: #fff;
}

.logo img {
    height: 32px;
    width: 142px;
}

.navigation ul {
    list-style: none;
    display: flex;
    gap: 1rem;
}

.navigation li {
    padding: 0.5rem 1rem;
}

.navigation a {
    text-decoration: none;
    color: #000;
}

.navigation a.router-link-active {
    color: #00235C;
}

.navigation a.router-link-exact-active {
    background-color: #00235C;
    color: #fff;
    border-radius: 5px;
    padding: 0.5rem 1rem;
}

.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    padding-top: 0px;
    border-radius: 10px;
    background-color: white;
    border-radius: 8px;
}

.document-container {
    max-height: 500px;
    min-height: 250px;
    max-width: 600px;
    padding-right: 25px;
    padding-left: 25px;
    overflow: hidden scroll;
}

.document-container-mobile {
    max-height: 400px;
    min-height: 200px;
    max-width: calc(100% - 40px);
    padding: 15px;
    margin: 0 30px;
}

.logomark {
    width: 54px;
    height: 43.2px;
}

.termos-row {
  display: flex;
  align-items: center;
  justify-content: center;  /* centraliza no container */
  gap: 10px;
  margin: 16px 0;
  width: 100%;
}

input {
    width: auto !important;
    margin-bottom: 5px !important;
}

.termos-text {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 1.4;
  text-align: left; /* mantém o texto alinhado normal */
  color: #6E6E6E;
}

.signed-card {
  width: 100%;
  max-width: 600px;
  margin: 12px auto 0;
  padding: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fafafa;
}

.signed-card h3 {
  margin: 0 0 8px;
  text-align: center;
}

.signed-meta {
  list-style: none;
  padding: 0;
  margin: 0 0 12px;
  color: #374151;
  font-size: 14px;
}
.signed-meta li { margin: 4px 0; }

.document-preview {
  max-height: 400px;
  overflow: auto;
  padding: 12px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 6px;
  margin-bottom: 12px;
}

.signed-actions {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
}


.submit-button {
    width: 100%;
    padding: 0.5rem;
    margin-top: 1rem;
    color: white;
    border: none;
    background: #03204f;
    text-align: center;
    border: 1px solid #5E84C3;
    border-radius: 8px;
    cursor: pointer;
}

.header {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
}

.header h2 {
    width: 360px;
    height: 38px;
    font-family: 'Gabarito', sans-serif;
    font-weight: 600;
    font-size: 30px;
    line-height: 38px;
    text-align: center;
    margin: 0 auto;
    color: #101828;
    margin-top: 20px;
}

.header p {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #6E6E6E;
}

.footer p {
    font-family: 'Inter', sans-serif;
    color: #667085;
    font-size: 16px;
    line-height: 24px;
}

.footer a {
    font-weight: 600;
    color: #101828;
    text-decoration: none;
}

button {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
}

.entrar-button {
    color: #667085;
    background: white;
    cursor: pointer;
}

input {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    padding: 10px;
    margin-bottom: 16px;
    border: 1px solid #ccc;
    border-radius: 8px;
    box-sizing: border-box;
    width: 100%;
}

.erroBorder {
    border: 1px solid #E73D3D !important;
    margin-bottom: 0px;
}

.erro {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    margin-top: 0px;
    color: #E73D3D;
}

.form .input-field label {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #344054;
}

form {
    display: flex;
    flex-direction: column;
}

input {
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

button {
    padding: 10px;
    background-color: #00235C;
    ;
    color: white;
    border: none;
    border-radius: 4px;
    text-align: center;
}

@media (max-width: 768px) {
    .login-container {
        margin: 20px;
        padding: 10px;
    }

    input,
    button {
        margin-bottom: 10px;
    }
    
    .container {
        padding: 20px;
        margin: 15px;
        width: calc(100% - 30px);
    }
    
    .header h3 {
        font-size: 18px;
        padding: 0 15px;
        text-align: center;
    }
    
    .header p {
        font-size: 14px;
        padding: 0 15px;
        text-align: center;
    }
    
    .submit-button {
        width: 90% !important;
    }
    
    .site-header {
        padding: 0 1rem;
    }
    
    .logo-mobile {
        margin-top: 15px !important;
        margin-bottom: 15px !important;
    }
}

h2 {
    text-align: center;
    margin-bottom: 20px;
}

.forgot-password {
    font-family: 'Inter', sans-serif;
    display: block;
    text-align: center;
    margin-bottom: 20px;
    font-weight: 600;
    color: #00064F;
    text-decoration: none;
}

.signup {
    text-align: center;
    margin-top: 20px;
}

.signup a {
    color: blue;
    text-decoration: none;
}
</style>